/**
 * URL-safe shared secret for n8n X-API-KEY (matches backend secrets.token_urlsafe(32)).
 */
export function generateWebhookToken() {
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  let binary = "";
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

/**
 * Derive n8n test webhook URL from production URL.
 * https://host/webhook/{id} -> https://host/webhook-test/{id}
 */
export function toTestWebhookUrl(productionUrl) {
  const url = (productionUrl || "").trim();
  if (!url) return "";
  if (url.includes("/webhook-test/")) return url;
  if (!url.includes("/webhook/")) return "";
  return url.replace("/webhook/", "/webhook-test/");
}

/**
 * Suggested n8n callback URL for the current environment.
 * n8n must reach the tickets *backend* (not the Vite dev server on :3000).
 */
export function getSuggestedN8nCallbackUrl() {
  const path = "/api/v1/tickets/webhooks/n8n";
  const explicitBase = import.meta.env.VITE_TICKETS_API_URL;

  if (explicitBase && /^https?:\/\//i.test(explicitBase)) {
    return `${explicitBase.replace(/\/$/, "")}/webhooks/n8n`;
  }

  const hostname =
    typeof window !== "undefined" ? window.location.hostname : "localhost";

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    const port = import.meta.env.VITE_TICKETS_API_PORT || "8006";
    return `http://${hostname}:${port}${path}`;
  }

  if (typeof window !== "undefined") {
    return `${window.location.origin}${path}`;
  }

  return path;
}
